import { useLPQuery } from '../lib/hooks/useLPQuery';
import type { UseQueryOptions } from '@tanstack/react-query';

export type StartVoluntaryTrainingResponse = {
  isLoading: boolean;
};

export type StartVoluntaryTrainingQueryParams = {
  id: string;
  options?: Omit<
    UseQueryOptions<StartVoluntaryTrainingResponse, unknown, StartVoluntaryTrainingResponse>,
    'queryKey' | 'queryFn'
  >;
};

export const useStartVoluntaryTrainingQuery = ({ id, options }: StartVoluntaryTrainingQueryParams) => {
  return useLPQuery<StartVoluntaryTrainingResponse>(
    ['startVoluntaryTraining', id],
    `/voluntary-campaign/${id}/check`,
    options,
  );
};
